import { Plus } from "lucide-react";

import { withForm } from "~/components/form/app-form";
import { ArrayItemCard } from "~/components/form/fields/array-item-card";
import { Button } from "~/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const FaqsSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>FAQs</CardTitle>
          <CardDescription>Add frequently asked questions</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.Field name="faqs" mode="array">
            {(arrayField) => (
              <>
                {(arrayField.state.value ?? []).map((item, i) => (
                  <ArrayItemCard
                    key={i}
                    index={i}
                    isFirst={i === 0}
                    isLast={i === (arrayField.state.value?.length ?? 0) - 1}
                    isDeleted={item._delete === true}
                    itemLabel="FAQ"
                    onMoveUp={() => arrayField.moveValue(i, i - 1)}
                    onMoveDown={() => arrayField.moveValue(i, i + 1)}
                    onToggleDelete={() =>
                      form.setFieldValue(`faqs[${i}]._delete`, !item._delete)
                    }
                  >
                    <form.AppField name={`faqs[${i}].question`}>
                      {(field) => <field.TextField label="Question" required />}
                    </form.AppField>
                    <form.AppField name={`faqs[${i}].answer`}>
                      {(field) => (
                        <field.TextareaField label="Answer" maxLength={500} />
                      )}
                    </form.AppField>
                  </ArrayItemCard>
                ))}
                <Button
                  type="button"
                  variant="ghost"
                  onClick={() =>
                    arrayField.pushValue({
                      question: "",
                      answer: "",
                      order: arrayField.state.value?.length ?? 0,
                      _delete: false,
                    })
                  }
                >
                  <Plus className="mr-2 h-4 w-4" /> Add FAQ
                </Button>
              </>
            )}
          </form.Field>
        </CardContent>
      </Card>
    );
  },
});
